(() => {
  const h = document.querySelector('[data-h16]');
  if (!h) return;
  // D478 (L2, 4 Nov 2026): the sign-in links carry return_url=<this page's path> (Liquid); add the query string here so a visitor lands back on the same page
  if (location.search) {
    document.querySelectorAll('a[href*="return_url="]').forEach((a) => {
      try {
        const u = new URL(a.href, location.origin);
        if (u.searchParams.get('return_url') === location.pathname) { u.searchParams.set('return_url', location.pathname + location.search); a.href = u.toString(); }
      } catch (e) { /* leave the link as Liquid wrote it */ }
    });
  }
  const syncDown = () => document.documentElement.classList.toggle('h16-down', h.classList.contains('away'));
  const cats = h.querySelector('.h16-cats');
  const fit = () => {
    if (!cats) return;
    h.classList.remove('h16-tight', 'h16-nobar');
    if (window.innerWidth < 1000) return;
    if (cats.scrollWidth > cats.clientWidth + 1) {
      h.classList.add('h16-tight');
      if (cats.scrollWidth > cats.clientWidth + 1) h.classList.add('h16-nobar');
    }
  };
  fit();
  addEventListener('resize', fit, { passive: true });
  if (document.fonts) document.fonts.ready.then(fit);
  const drawer = document.getElementById('drawer16');
  const buttons = [...h.querySelectorAll('button[aria-controls]')];
  if (drawer) buttons.push(...drawer.querySelectorAll('button[aria-controls]'));
  const pairs = buttons.map(b => [b, document.getElementById(b.getAttribute('aria-controls'))])
    .filter(p => p[1] && !p[1].classList.contains('srch16'));
  /* F90-NAV (D109, 22 Oct 2026): how a menu was opened ('hover' or 'click'), the timers of the hover intent and the pointer watch of a menu that hover opened */
  const how = new Map();
  let openTimer = 0, closeTimer = 0, pending = null, watching = null;
  const unwatch = el => {
    if (!watching || (el && watching.el !== el)) return;
    document.removeEventListener('pointermove', watching.move);
    document.documentElement.removeEventListener('mouseleave', watching.leave);
    clearTimeout(closeTimer);
    closeTimer = 0;
    watching = null;
  };
  const setOpen = (el, open) => {
    if (!open) { how.delete(el); unwatch(el); }
    el.hidden = !open;
    pairs.filter(p => p[1] === el).forEach(p => p[0].setAttribute('aria-expanded', String(open)));
    if (el === drawer) document.documentElement.classList.toggle('drawer-open', open);
    if (open) h.classList.remove('away');
    syncDown();
  };
  const closeAll = except => pairs.forEach(([, el]) => {
    if (el !== except && !el.hidden) setOpen(el, false);
  });
  let last = window.scrollY;
  const updateScroll = () => {
    const y = window.scrollY;
    h.classList.toggle('scrolled', y > 24);
    if (window.innerWidth < 900 && !pairs.some(([, el]) => !el.hidden)) {
      if (y > last + 8 && y > 120) h.classList.add('away');
      else if (y < last - 8) h.classList.remove('away');
    }
    syncDown();
    last = y;
  };
  addEventListener('scroll', () => {
    updateScroll();
    setTimeout(updateScroll, 0);
  }, { passive: true });
  /* F90-NAV (D109, 22 Oct 2026): the menus open on hover for a mouse, with hover intent, and keep working for click, keyboard and touch.
     A mouse that rests on a menu button for 120 ms opens its panel (and closes any other); the panel closes 250 ms after the pointer has left the button, the panel and the strip between them.
     A click on the button of a panel that hover opened PINS it (it used to shut it, so a visitor who hovered and then clicked saw the menu flash away); a pinned panel closes on a second click, Escape, a click outside or another menu.
     Only a mouse counts (pointerType) on a device whose main pointer hovers; touch and keyboard are as before. The covers inside a panel start loading as soon as the pointer comes near, so they are there when the panel opens. */
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const OPEN_MS = 120, CLOSE_MS = 250;
  const hoverable = b => b.classList.contains('c16') || b.classList.contains('h16-lang') || b.classList.contains('h16-me');
  const warm = el => el.querySelectorAll('img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
  const stopTimers = () => { clearTimeout(openTimer); pending = null; unwatch(null); };
  const within = (r, x, y) => x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  const zoneHas = (b, el, x, y) => {
    const a = b.getBoundingClientRect(), p = el.getBoundingClientRect();
    return within(a, x, y) || within(p, x, y) || (x >= a.left - 28 && x <= a.right + 28 && y >= a.bottom && y <= p.top);
  };
  const watch = (b, el) => {
    unwatch(null);
    const arm = () => {
      if (closeTimer) return;
      closeTimer = setTimeout(() => { closeTimer = 0; if (!el.hidden && how.get(el) === 'hover') setOpen(el, false); }, CLOSE_MS);
    };
    const disarm = () => { clearTimeout(closeTimer); closeTimer = 0; };
    watching = {
      el,
      b,
      move: e => { if (e.pointerType === 'mouse') { if (zoneHas(b, el, e.clientX, e.clientY)) disarm(); else arm(); } },
      leave: arm
    };
    document.addEventListener('pointermove', watching.move, { passive: true });
    document.documentElement.addEventListener('mouseleave', watching.leave);
  };
  pairs.forEach(([b, el]) => {
    b.addEventListener('click', e => {
      e.stopPropagation();
      clearTimeout(openTimer);
      pending = null;
      warm(el);
      if (!el.hidden && how.get(el) === 'hover') { how.set(el, 'click'); unwatch(el); return; }
      const open = el.hidden;
      closeAll(el);
      setOpen(el, open);
      if (open) how.set(el, 'click');
      if (open && el !== drawer) {
        const input = el.querySelector('input[type=search]');
        if (input) input.focus();
      }
    });
    if (hoverable(b)) {
      b.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse' || !fine.matches) return;
        warm(el);
        if (!el.hidden) return;
        if (watching && watching.el !== el && zoneHas(watching.b, watching.el, e.clientX, e.clientY)) return;   // on its way to the open panel the pointer crosses other buttons: they do not take the menu over
        clearTimeout(openTimer);
        pending = b;
        openTimer = setTimeout(() => {
          pending = null;
          closeAll(el);
          setOpen(el, true);
          how.set(el, 'hover');
          watch(b, el);
          b.dispatchEvent(new CustomEvent('h16open'));
        }, OPEN_MS);
      });
      b.addEventListener('pointerleave', () => {
        if (pending === b) { clearTimeout(openTimer); pending = null; }
      });
    }
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.m16, .d16-panel, .srch16')) {
      stopTimers();
      closeAll(null);
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      stopTimers();
      closeAll(null);
    }
  });
  if (drawer) {
    drawer.querySelectorAll('.d16-x').forEach(x => x.addEventListener('click', () => closeAll(null)));
    drawer.addEventListener('click', e => { if (e.target === drawer) closeAll(null); });
  }

  const safePath = value => {
    if (typeof value !== 'string') return '';
    if (value.startsWith('/') && !value.startsWith('//')) return value;
    try {
      const url = new URL(value, location.href);
      if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
    } catch (e) { return ''; }
    return '';
  };
  const me = h.querySelector('.h16-me');
  if (me) {
    const panel = h.querySelector('#me16');
    const rd = panel.querySelector('[data-me-rd]');
    const sw = panel.querySelector('[data-me-sw]');
    const now = panel.querySelector('[data-me-now]');
    const library = panel.querySelector('.me16-nav a').getAttribute('href');
    const originalName = me.querySelector('.nm').textContent;
    let reader = 1, asked = false;
    try {
      const stored = Number(localStorage.getItem('loa-reader'));
      if (Number.isInteger(stored) && stored >= 1 && stored <= 5) reader = stored;
    } catch (e) { /* Storage can be unavailable. */ }
    const avatarClass = n => 'av16' + (n === 2 || n === 3 ? ' av' + n : '');
    const letter = name => Array.from(name)[0].toUpperCase();
    const get = async url => {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error();
      return response.json();
    };
    const loadMe = () => {
      if (asked) return;
      asked = true;
      get(h.dataset.readers).then(data => {
        if (!Array.isArray(data.readers)) return;
        const active = data.readers.find(r => Number(r.reader) === reader);
        const name = active && active.name ? String(active.name) : originalName;
        me.querySelector('.nm').textContent = name;
        if (h.dataset.tMe) me.setAttribute('aria-label', name + ', ' + h.dataset.tMe.replace('%NAME%', () => name));   // the button's name starts with its visible text (WCAG 2.5.3)
        panel.querySelector('.me16-who b').textContent = name;
        const mav = me.querySelector('.av16');
        mav.dataset.l = letter(name);   // the button's letter is drawn from data-l (the span stays empty), so the button's text is the name only (snippets/library-v16-header.liquid)
        mav.className = avatarClass(reader);
        const pav = panel.querySelector('.me16-who .av16');
        pav.textContent = letter(name);
        pav.className = avatarClass(reader);
        rd.replaceChildren();
        data.readers.forEach(r => {
          const n = Number(r.reader);
          if (!Number.isInteger(n) || n < 1 || n > 5 || n === reader || !r.name) return;
          const a = document.createElement('a');
          a.href = library + '?reader=' + n;
          const av = document.createElement('span');
          av.className = avatarClass(n);
          av.setAttribute('aria-hidden', 'true');
          av.textContent = letter(String(r.name));
          a.appendChild(av);
          a.appendChild(document.createTextNode(String(r.name)));
          a.addEventListener('click', e => {
            e.preventDefault();
            try { localStorage.setItem('loa-reader', String(n)); } catch (err) { /* Keep navigation available. */ }
            location.reload();
          });
          rd.appendChild(a);
        });
        sw.hidden = rd.hidden = !rd.children.length;
      }).catch(() => {});
      get(h.dataset.places + '?reader=' + reader + '&limit=1').then(data => {
        const p = data.places && data.places[0];
        if (!p || !['read', 'listen'].includes(p.mode) || !p[p.mode]) return;
        now.href = (h.dataset.root || '').replace(/\/+$/, '') + '/products/' + encodeURIComponent(p.handle) + '?open=' + p.mode;
        const img = now.querySelector('img');
        const cover = safePath(p.cover);
        img.hidden = !cover;
        if (cover) img.src = cover + (cover.includes('?') ? '&' : '?') + 'width=160';
        now.querySelector('b').textContent = p.name || '';
        let where = '';
        if (p.mode === 'read') {
          const title = typeof p.chapter_title === 'string' ? p.chapter_title.trim() : '';
          where = title ? h.dataset.tWr.replace(/%TITLE%|%CHAPTER%|%TOTAL%/g, key =>
            key === '%TITLE%' ? title : key === '%CHAPTER%' ? p.read.chapter : p.chapters) : h.dataset.tWn;
        } else if (p.left_seconds != null) {
          const minutes = Math.floor(p.left_seconds / 60);
          const time = (minutes >= 60 ? h.dataset.tHm : h.dataset.tM)
            .replace(/%H%/g, () => Math.floor(minutes / 60))
            .replace(/%M%/g, () => minutes >= 60 ? minutes % 60 : minutes);
          where = h.dataset.tWl.replace(/%LEFT%/g, () => time);
        }
        now.querySelector('.w').textContent = where;
        now.hidden = false;
      }).catch(() => {});
    };
    me.addEventListener('click', loadMe);
    me.addEventListener('h16open', loadMe);   // F90-NAV: a panel that hover opened loads the readers and the place, as a click does
    if (reader !== 1) loadMe();
  }

  /* the Authors group and the well-known author's books (listed first) come from the authors index (assets/library-authors-index.json, 1,829 rows [handle, name, letter, era, country, kind, most-read position, description, portrait]), loaded on the first focus; books and collections are Shopify's, in its order (D55) */
  let authorsIndex = null, authorsAsked = false;
  const fold = t => String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const tokens = x => fold(x || '').split(/[\s.,:;'’()&!?-]+/).filter(Boolean);
  const loadAuthors = url => {
    if (authorsAsked || !url) return;
    authorsAsked = true;
    fetch(url).then(r => (r.ok ? r.json() : [])).then(rows => { authorsIndex = Array.isArray(rows) ? rows : []; }).catch(() => { authorsIndex = []; });
  };
  const key = 'loa-recent-searches';
  const recent = () => {
    try {
      const rows = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(rows) ? rows.filter(x => typeof x === 'string').slice(0, 5) : [];
    } catch (e) { return []; }
  };
  const remember = v => {
    v = (v || '').trim();
    if (v.length < 2) return;
    try { localStorage.setItem(key, JSON.stringify([v, ...recent().filter(x => x.toLowerCase() !== v.toLowerCase())].slice(0, 5))); } catch (e) { /* Storage is optional. */ }
  };
  const popular = [['Pride and Prejudice', 'pride and prejudice'], ['Sherlock Holmes', 'sherlock holmes'],
    ['Greek myths', 'greek myths'], ['Meditations', 'meditations'], ['The Bible', 'bible'],
    ['Audiobooks', 'audiobooks'], ['Large print', 'large print']];
  h.querySelectorAll('.h16-search, .srch16').forEach(form => {
    const input = form.querySelector('input[type=search]');
    if (!input) return;
    /* UX-1 (UX-024, 27 Oct 2026): below 1200 px the search button takes the right part of the bar and the long placeholder was cut mid-sentence ("Search 200,000+ books, authors and"); the short line (data-ph-short) takes its place there */
    if (input.dataset.phShort && window.matchMedia) {
      const narrow = matchMedia('(max-width:1199px)'), long = input.placeholder;
      const place = () => { input.placeholder = narrow.matches ? input.dataset.phShort : long; };
      place();
      if (narrow.addEventListener) narrow.addEventListener('change', place); else if (narrow.addListener) narrow.addListener(place);
    }
    const root = form.getAttribute('action').replace(/search\/?$/, '');
    const go = v => root + 'search?q=' + encodeURIComponent(v) + '&type=product';
    const word = (name, fallback) => form.dataset[name] || fallback;
    let chips = popular;
    try {
      const value = JSON.parse(form.dataset.popular);
      if (Array.isArray(value) && value.length && value.every(p => Array.isArray(p) && p.length === 2 && p.every(x => typeof x === 'string'))) chips = value;
    } catch (e) { /* Use the default list. */ }
    const node = (tag, cls, text, parent) => {
      const el = document.createElement(tag);
      if (cls) el.className = cls;
      if (text != null) el.textContent = text;
      if (parent) parent.appendChild(el);
      return el;
    };
    const box = node('div', 'h16-sug', null, form);
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    box.setAttribute('aria-label', word('tLabel', 'Search suggestions'));
    let revision = 0;
    const close = () => { revision++; box.hidden = true; };
    const anchor = (parent, title, url, q, cls) => {
      const a = node('a', cls, title, parent);
      a.setAttribute('href', safePath(url));
      a.setAttribute('data-q', q);
      return a;
    };
    const popularBox = () => {
      node('p', 'g', word('tPopular', 'Popular searches'), box);
      const wrap = node('div', 'chips', null, box);
      chips.forEach(([n, v]) => anchor(wrap, n, go(v), v));
      box.hidden = false;
    };
    const empty = () => {
      box.replaceChildren();
      const rows = recent();
      if (rows.length) {
        const hd = node('div', 'hd', null, box);
        node('p', 'g', word('tRecent', 'Recent searches'), hd);
        const clear = node('button', 'clr', word('tClear', 'Clear'), hd);
        clear.type = 'button';
        clear.setAttribute('data-clear', '');
        /* the clock is a fixed string parsed as HTML (a parsed svg gets its namespace by itself); the search words are set as text only */
        const clock = new DOMParser().parseFromString('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 7.5V12l3 2"/></svg>', 'text/html').body.firstChild;
        rows.forEach(v => {
          const a = anchor(box, null, go(v), v, 'qs');
          node('span', 'c', null, a).appendChild(clock.cloneNode(true));
          node('b', '', v, node('span', '', null, a));
        });
      }
      popularBox();
    };
    const nomatch = text => {   /* nothing matches and nothing to correct: say so and offer the popular searches, no loose hits (design 68298cc9) */
      box.replaceChildren();
      node('p', 'dym', word('tNomatch', 'No books match “{{ q }}”.').replace(/\{\{\s*q\s*\}\}/g, () => text), box);
      popularBox();
    };
    const link = (title, url, image, subtitle, author, q, shelf) => {
      if (!safePath(url)) return;
      const a = anchor(box, null, url, q);
      if (image && safePath(image)) {
        const img = node('img', author ? 'r' : '', null, a);
        img.src = safePath(image);
        img.width = author ? 36 : 32;
        img.height = author ? 36 : 48;
        img.alt = '';
      }
      if (shelf) node('span', 'c', '▤', a).setAttribute('aria-hidden', 'true');
      const span = node('span', '', null, a);
      node('b', '', title, span);
      if (subtitle) node('small', '', subtitle, span);
    };
    /* H10: Shopify's predictive search section rendering gives full products (the author, not the imprint) and lets the section drop large print twins */
    const suggest = async query => {
      const response = await fetch(root + 'search/suggest?section_id=library-v16-suggest&q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each');
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const out = { products: [], collections: [] };
      doc.querySelectorAll('li[data-k]').forEach(li => {
        if (li.dataset.k === 'p') out.products.push({ title: li.dataset.title, url: li.dataset.url, image: li.dataset.image, vendor: li.dataset.author });
        else out.collections.push({ title: li.dataset.title, url: li.dataset.title ? li.dataset.url : '' });
      });
      return out;
    };
    /* MEM-2 (W29): the service's other groups (best, summaries, characters, help, pages) with the shop's, never holding the books back (1.5 s); names, covers and sub lines are its data, links paths on this site, five rows; a fix in the answer is only offered */
    /* QUALITY-2 (24 Oct 2026): the right book first. The shop's plain ranking weighs the long descriptions (measured on the live shop: "art of war" puts The Art of War 16th, "the republic" 14th, "ethics" nowhere in the
       first ten), so the box also asks for the TITLE as a phrase (title:"art of war" gives The Art of War first), for the words as a quoted phrase (finds Josephus's Against Apion), and the service for its books.
       Pure rules pinned by website/tools/sol-build/tasks/q2-search-books/tests. */
    const phrase = t => String(t == null ? '' : t).replace(/[‘’ʼ]/g, "'").replace(/["':()\\*~^[\]{}<>|]/g, c => (c === "'" ? c : ' ')).replace(/\s+/g, ' ').replace(/^[\s-]+/, '').trim().slice(0, 80);
    const suggestBooks = async query => {   // products only, six at most; a failing or slow shop gives nothing (1.5 s)
      const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 1500);
      try {
        const response = await fetch(root + 'search/suggest?section_id=library-v16-suggest&q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[limit_scope]=each', { signal: ctl.signal });
        if (!response.ok) return [];
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...doc.querySelectorAll('li[data-k="p"]')].map(li => ({ title: li.dataset.title, url: li.dataset.url, image: li.dataset.image, vendor: li.dataset.author }));
      } catch (e) { return []; } finally { clearTimeout(timer); }
    };
    /* the books in order: the exact title first, then the titles that start with the typed words (a leading article does not count), then the order the sources came in; each address once */
    const art = a => (a.length > 1 && /^(the|a|an)$/.test(a[0]) ? a.slice(1) : a);   // a leading article is no part of a title's identity
    const rank = (typed, lists, keep) => {
      const me = art(typed).join(' '), seen = new Set(), out = [];
      lists.forEach(list => (list || []).forEach(p => {
        if (!p || !p.title || !p.url) return;
        const key = p.url.split('?')[0].replace(/\/+$/, '');
        if (seen.has(key)) return;
        seen.add(key);
        const t = art(tokens(p.title)).join(' ');
        out.push({ p, score: t === me ? 3 : t.startsWith(me) ? 2 : 1, order: out.length });
      }));
      return (keep ? out : out.sort((a, b) => b.score - a.score || a.order - b.order)).map(x => x.p);
    };
    /* 08-closest:start (chat 08, 28 Oct 2026): the fallback when no book holds every typed word. Shopify answers a slip ("prejuduce") with loose hits that only mention a word
       somewhere (The International Jew under Pride and Prejudice); only books whose title or author words are close to EVERY typed word stay: each typed word (3 letters or more,
       stop words left out) must be within 1 edit (words of 4 letters or fewer) or 2 edits of a title or author word or of its start; closest first, the shop's order breaks ties. */
    const lev = (a, b) => {
      if (a === b) return 0;
      let prev = Array.from({ length: b.length + 1 }, (_, j) => j);
      for (let i = 1; i <= a.length; i++) {
        const cur = [i];
        for (let j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = cur;
      }
      return prev[b.length];
    };
    const closest = (typed, list) => {
      const words = typed.filter(w => w.length >= 3 && !/^(the|and|for|with|from|that|this|his|her|its|our|are|was|has|not|you|but|all|any|out|one|book|books)$/.test(w));
      if (!words.length) return [];
      const out = [];
      (list || []).forEach((p, order) => {
        if (!p || !p.title) return;
        const ws = tokens(p.title).concat(tokens(p.vendor));
        let total = 0;
        for (const w of words) {
          const allow = w.length <= 4 ? 1 : 2;
          const best = Math.min(...ws.map(x => Math.min(lev(w, x), x.length > w.length ? lev(w, x.slice(0, w.length)) : Infinity)));
          if (best > allow) return;
          total += best;
        }
        out.push({ p, total, order });
      });
      return out.sort((a, b) => a.total - b.total || a.order - b.order).map(x => x.p);
    };
    /* 08-closest:end */
    /* typing slips and name forms the shop knows (offer.search.aliases for the language: { words: { typed: right }, queries: { "whole typed words": "words to search instead" } }) */
    let aliases = null;
    try { aliases = JSON.parse(form.dataset.aliases || 'null'); } catch (e) { /* none */ }
    const aliasOf = text => {
      if (!aliases || typeof aliases !== 'object') return '';
      const w = tokens(text);
      if (!w.length) return '';
      const key = w.join(' '), whole = aliases.queries && aliases.queries[key];
      if (typeof whole === 'string' && whole) return whole;
      let changed = false;
      const out = w.map(x => { const r = aliases.words && aliases.words[x]; if (typeof r === 'string' && r) { changed = true; return r; } return x; });
      return changed ? out.join(' ') : '';
    };
    /* words that ask for a summary or a study aid are no part of a title ("hamlet summary", "summary of hamlet", "sparknotes hamlet" search for hamlet; its summary page is in the box's Summaries) */
    const intentStrip = q => {
      const src = String(q == null ? '' : q).replace(/\s+/g, ' ').trim();
      let t = src.replace(/\b(?:book |chapter |plot )?(?:summary|summaries|synopsis)\b|\bstudy guide\b|\b(?:spark|cliffs?) ?notes\b|\banalysis\b/gi, ' ').replace(/\s+/g, ' ').trim();
      if (t === src) return '';   // no such word was there: the words stay as typed
      t = t.replace(/^(?:of|for|on|about)\s+/i, '').replace(/\s+(?:of|for|on|about)$/i, '').trim();
      return t.length >= 3 ? t : '';
    };
    /* a spelling fix is followed only when each word it changes is one slip away, or two slips in a word of eight letters or more ("corpus" -> "cyrus" is two slips in a short word) */
    const slips = (a, b) => {
      const d = [];
      for (let i = 0; i <= a.length; i++) d[i] = [i];
      for (let j = 1; j <= b.length; j++) d[0][j] = j;
      for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
      return d[a.length][b.length];
    };
    const fixOk = (text, fix) => {
      const a = tokens(text), b = tokens(fix);
      if (!a.length || a.length !== b.length) return false;
      return a.every((w, i) => { if (w === b[i]) return true; const n = slips(w, b[i]); return n < 2 || (n === 2 && w.length >= 8); });
    };
    const sitePath = v => {
      const s = typeof v === 'string' && !v.startsWith('//') ? safePath(v) : '';
      if (!s || s.startsWith('/')) return s;
      const u = new URL(s);
      return u.pathname + u.search + u.hash;
    };
    const askSite = text => {
      const base = form.dataset.service;
      const url = base && safePath(`${base.replace(/\/$/, '')}/api/search?q=${encodeURIComponent(text)}&lang=${encodeURIComponent(document.documentElement.lang || 'en')}&kinds=book,best,summary,character,help,page&limit=5`);
      if (!url) return Promise.resolve({ groups: [], fix: '', books: [] });
      const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 1500);
      return fetch(url, { signal: ctl.signal }).then(r => (r.ok ? r.json() : null)).catch(() => null).then(a => {
        clearTimeout(timer);
        const fix = a && typeof a.fix === 'string' ? a.fix : '', groups = [], books = [];
        let left = 5;
        if (!fix && a && Array.isArray(a.groups)) a.groups.forEach(g => {
          if (g && g.kind === 'book') {   // QUALITY-2: the service's books join the shop's books (merged in gather), they are not a group of their own
            (Array.isArray(g.items) ? g.items : []).forEach(i => {
              if (i && typeof i.title === 'string' && i.title && sitePath(i.url)) books.push({ title: i.title, url: sitePath(i.url), image: typeof i.cover === 'string' ? i.cover : '', vendor: typeof i.sub === 'string' ? i.sub : '' });
            });
            return;
          }
          const items = g && typeof g.label === 'string' && g.label && Array.isArray(g.items) ? g.items.filter(i => i && typeof i.title === 'string' && i.title && sitePath(i.url)).slice(0, Math.min(2, left)) : [];
          left -= items.length;
          if (items.length) groups.push({ label: g.label, items });
        });
        return { groups, fix, books };
      });
    };
    const gather = async (text, current) => {
      const asked = askSite(text);
      const plain = suggest(text);   // the shop's plain list is asked first, the two phrase questions follow at once
      const ph = phrase(text);
      const worth = tokens(text).some(w => w.length >= 3 && !/^(the|and|for|with|from|that|this|his|her|its|our|are|was|has|not|you|but|all|any|out|one)$/.test(w));   // "the" or "of the" would list every title that starts with an article
      const more = ph.length >= 2 && worth ? Promise.all([suggestBooks('title:"' + ph + '"'), suggestBooks('"' + ph + '"')]) : Promise.resolve([[], []]);
      const results = await plain;
      if (!results || current !== revision) return null;
      loadAuthors(form.dataset.authorsIndex);
      if (!authorsIndex && authorsAsked) await new Promise(r => setTimeout(r, 250));
      if (current !== revision) return null;
      const typed = tokens(text);
      const authors = (authorsIndex || []).filter(a => {
        const words = tokens(a[1]);
        return typed.every(w => words.some(x => x.startsWith(w)));
      }).sort((a, b) => a[6] - b[6]);
      const known = new Set(authors.filter(a => a[6] <= 150).map(a => fold(a[1])));
      const top = authors.find(a => a[6] <= 150);
      const extra = top ? ((await suggest(top[1])) || { products: [] }).products.filter(p => fold(p.vendor) === fold(top[1])) : [];
      const merged = results.products.concat(extra.filter(e => !results.products.some(p => p.url === e.url)));
      const own = p => known.has(fold(p.vendor));   /* the books of a well-known author the words name come first; every other book keeps Shopify's place */
      const has = ws => typed.every(w => ws.some(x => x.startsWith(w)));   /* a real match: the shop also answers misspellings with loose matches, so "nothing found" is "no result has every typed word" */
      const fits = p => has(tokens(p.title).concat(tokens(p.vendor)));
      const [titleHits, phraseHits] = await more;
      const found = await asked, site = found.groups;
      if (current !== revision) return null;
      /* QUALITY-2: the order of the books: the well-known author's books and the rest of the shop's plain list keep the shop's order as before (D55); between them stand the books the new questions found (the title phrase, the quoted phrase, the service),
         the exact title first, then the titles that start with the words, then the order they came in */
      const fresh = rank(typed, [titleHits, phraseHits, found.books]);
      const real = rank(typed, [merged.filter(own), fresh, merged.filter(p => !own(p))], true).filter(fits);   /* the design's rule: Books lists only the books that hold every typed word at a word start (title and author together); the shop's loose hits are the fallback when no book does */
      return { products: (real.length || site.length ? real : closest(typed, merged.filter(own).concat(merged.filter(p => !own(p))))).slice(0, 5), authors: authors.slice(0, 3), collections: results.collections.slice(0, 3),
        site, siteFix: found.fix, none: !site.length && !authors.length && !real.length && !results.collections.some(c => has(tokens(c.title))) };
    };
    const render = (text, data, fix) => {
      box.replaceChildren();
      if (fix) {
        const p = node('p', 'dym', null, box);
        const parts = word('tDym', 'Did you mean {{ q }}?').split(/\{\{\s*q\s*\}\}/);
        p.appendChild(document.createTextNode(parts[0]));
        anchor(p, text, go(text), text);
        p.appendChild(document.createTextNode(parts.slice(1).join(text)));
      }
      const books = () => {
        if (!data.products.length) return;
        node('p', 'g', word('tBooks', 'Books'), box);
        data.products.forEach(p => link(p.title, p.url, typeof p.image === 'string' ? p.image : p.image && p.image.url, p.vendor, false, text));
      };
      const authors = () => {
        if (!data.authors.length) return;
        node('p', 'g', word('tAuthors', 'Authors'), box);
        data.authors.forEach(a => {
          const file = a[8] || '';
          link(a[1], root + 'pages/authors/' + a[0], file ? (form.dataset.cdn || '') + file + (file.includes('?') ? '&' : '?') + 'width=80' : '', a[7], true, text);
        });
      };
      const shelves = () => {
        if (!data.collections.length) return;
        node('p', 'g', word('tCollections', 'Collections'), box);
        data.collections.forEach(c => link(c.title, c.url, '', '', false, text, true));
      };
      const first = tokens(text)[0];
      const shelfFirst = data.collections.some(c => tokens(c.title)[0] === first);
      if (shelfFirst) shelves();
      books();
      authors();
      if (!shelfFirst) shelves();
      data.site.forEach(g => {
        node('p', 'g', g.label, box);
        g.items.forEach(it => link(it.title, sitePath(it.url), typeof it.cover === 'string' ? it.cover : '', it.sub, false, text));
      });
      anchor(box, word('tAll', 'See every result for “{{ q }}”').replace(/\{\{\s*q\s*\}\}/g, () => text), go(text), text, 'all');
      box.hidden = false;
    };
    input.addEventListener('focus', () => {
      loadAuthors(form.dataset.authorsIndex);
      if (input.value.trim().length < 2) empty();
    });
    /* a word of a format is no part of a title ("l m montgomery large print"): when nothing is found the words are tried without it */
    const FORMAT = /\b(large[- ]print|audio ?books?|e-?books?|paperbacks?|hard ?(?:cover|back)s?|pdf|epub|kindle)\b/gi;
    const withoutFormat = t => t.replace(FORMAT, ' ').replace(/\s+/g, ' ').trim();
    const run = async (text, current) => {
      try {
        const alias = aliasOf(text);
        if (alias && alias.toLowerCase() !== text.toLowerCase()) {   // a slip or name form the shop knows: the right words, offered as "Did you mean"
          const viaAlias = await gather(alias, current).catch(() => null);
          if (current !== revision) return;
          if (viaAlias && !viaAlias.none) { render(alias, viaAlias, true); return; }
        }
        const bare0 = alias ? '' : intentStrip(text);
        if (bare0) {   // a summary or study-aid word: the box answers for the title, under the words typed (no "Did you mean": nothing was misspelled)
          const viaTitle = await gather(bare0, current).catch(() => null);
          if (current !== revision) return;
          if (viaTitle && !viaTitle.none) { render(text, viaTitle, false); return; }
        }
        const data = await gather(text, current);
        if (!data || current !== revision) return;
        if (!data.none) { render(text, data, false); return; }
        const plain = withoutFormat(text);
        if (plain.length >= 2 && plain.toLowerCase() !== text.toLowerCase()) {
          const bare = await gather(plain, current).catch(() => null);
          if (current !== revision) return;
          if (bare && !bare.none) { render(plain, bare, true); return; }
        }
        let fix = data.siteFix && fixOk(text, data.siteFix) ? data.siteFix : null;   /* the service's own fix first (never a two-slip change of a short word); nothing matches: the reading service may know the word; without a fix the box says so (the shop's loose hits are never shown) */
        if (!fix && !data.siteFix && form.dataset.service) {
          await new Promise(r => setTimeout(r, 250));
          if (current !== revision) return;
          const url = safePath(form.dataset.service.replace(/\/$/, '') + '/api/fix?q=' + encodeURIComponent(text)
            + '&lang=' + encodeURIComponent(document.documentElement.lang || 'en'));
          try {
            const response = url ? await fetch(url) : null;
            const answer = response && response.ok ? await response.json() : null;
            const word1 = answer && answer.fix;
            if (typeof word1 === 'string' && word1.trim() && word1.toLowerCase() !== text.toLowerCase() && fixOk(text, word1)) fix = word1;
          } catch (e) { /* No fix. */ }
        }
        const corrected = fix ? await gather(fix, current).catch(() => null) : null;
        if (current !== revision) return;
        if (corrected && !corrected.none) render(fix, corrected, true); else nomatch(text);
      } catch (e) { /* A failed predictive search shows nothing. */ }
    };
    let pause = 0;
    input.addEventListener('input', () => {
      const text = input.value.trim(), current = ++revision;
      clearTimeout(pause);
      if (text.length < 2) { empty(); return; }
      box.hidden = true;
      pause = setTimeout(() => run(text, current), 160);   /* QUALITY-2: one keystroke now asks the shop three times and the service once: the questions wait for a 160 ms pause in the typing */
    });
    form.addEventListener('submit', () => remember(input.value));
    box.addEventListener('click', e => {
      if (e.target.closest('[data-clear]')) {
        e.stopPropagation();
        try { localStorage.removeItem(key); } catch (err) { /* Storage is optional. */ }
        revision++;
        empty();
        input.focus();
        return;
      }
      const a = e.target.closest('a[data-q]');
      if (a) remember(a.dataset.q);
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }   /* a search field clears itself on Escape and fires input, which would open the empty box again */
      if (e.key === 'ArrowDown' && !box.hidden) {
        const first = box.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', e => {
      const links = [...box.querySelectorAll('a')];
      const i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) {
        e.preventDefault();
        links[i + 1].focus();
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        (i > 0 ? links[i - 1] : input).focus();
      }
      if (e.key === 'Escape') { input.focus(); close(); }
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) close(); });
  });
})();

/* DS-FIX-1 (28 Oct 2026): one helper for every bar that sits on the bottom edge of the screen. While a bar shows it sets data-fixedbar and --fixed-bottom (its height) on <html>; the design system CSS then reserves that space under the page and in scroll-padding, so no footer line or focused field is covered. Sticky bars (gift buy panel, summary trial bar) only set the scroll padding, because they already sit in the flow. */
(() => {
  const root = document.documentElement;
  const FIXED = '.bp-bar,.mc-bar,.sticky,.lib-au-bar,.pz-bar,.k5-appbar,.lib-bar,.ds-fixedbar';
  const STICKY = '.gf16-buy,.bs19-sticky,.lo-bar';
  let raf = 0;
  const shown = el => {
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
    const r = el.getBoundingClientRect();
    if (r.height < 1 || r.top >= window.innerHeight - 1 || r.bottom < window.innerHeight - 1) return 0;
    return Math.ceil(r.height);
  };
  const run = () => {
    raf = 0;
    let fixed = 0, sticky = 0;
    document.querySelectorAll(FIXED).forEach(el => { if (getComputedStyle(el).position === 'fixed') fixed = Math.max(fixed, shown(el)); });
    document.querySelectorAll(STICKY).forEach(el => { if (getComputedStyle(el).position === 'sticky') sticky = Math.max(sticky, shown(el)); });
    if (fixed) { root.dataset.fixedbar = ''; root.style.setProperty('--fixed-bottom', fixed + 'px'); }
    else { delete root.dataset.fixedbar; root.style.removeProperty('--fixed-bottom'); }
    root.style.scrollPaddingBottom = !fixed && sticky ? sticky + 16 + 'px' : '';
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(run); };
  if (!document.querySelector(FIXED + ',' + STICKY)) return;
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('transitionend', queue, true);
  new MutationObserver(queue).observe(document.body, { attributes: true, attributeFilter: ['class', 'hidden', 'style'], subtree: true });
  if (document.readyState === 'complete') queue(); else window.addEventListener('load', queue);
  queue();
})();

/* D478 (L2, 5 Nov 2026): the Shopify account component opens on hover like the other header panels (a mouse that rests 120 ms opens it; it closes 250 ms after the pointer leaves, unless the visitor typed in it or clicked to pin it). Touch and keyboard: the component's own tap/click. */
(() => {
  const host = document.querySelector('shopify-account.h16-sa');
  if (!host || !window.matchMedia) return;
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  let openT = 0, closeT = 0, byHover = false, pinned = false;
  // was: const place = () => { const r = host.getBoundingClientRect(); host.style.setProperty('--h16-sa-r', Math.max(16, Math.round(document.documentElement.clientWidth - r.right)) + 'px'); };
  // the CSS (converted to logical sides by v16_css.py) uses inset-inline-end: the distance from the inline end, i.e. from the left edge on right-to-left pages
  const place = () => { const r = host.getBoundingClientRect(); const rtl = getComputedStyle(document.documentElement).direction === 'rtl'; host.style.setProperty('--h16-sa-r', Math.max(16, Math.round(rtl ? r.left : document.documentElement.clientWidth - r.right)) + 'px'); };
  place(); addEventListener('resize', place, { passive: true }); host.addEventListener('pointerdown', place, true);
  const parts = () => { const r = host.shadowRoot; return r ? { btn: r.querySelector('button.account-button, button'), dlg: r.querySelector('dialog') } : {}; };
  const isOpen = () => { const { dlg } = parts(); return !!(dlg && dlg.open); };
  const busy = () => { const r = host.shadowRoot, a = r && r.activeElement; return !!(a && /INPUT|TEXTAREA|SELECT/.test(a.tagName)); };
  host.addEventListener('pointerenter', e => {
    if (e.pointerType !== 'mouse' || !fine.matches) return;
    clearTimeout(closeT);
    if (isOpen()) return;
    place();
    openT = setTimeout(() => { const { btn } = parts(); if (btn && !isOpen()) { byHover = true; pinned = false; btn.click(); } }, 120);
  });
  host.addEventListener('pointerleave', e => {
    if (e.pointerType !== 'mouse') return;
    clearTimeout(openT);
    if (!byHover || pinned) return;
    closeT = setTimeout(() => {
      if (!isOpen() || pinned || busy()) return;
      const r = host.shadowRoot, c = r && r.querySelector('#close-button');
      if (c) c.click(); else { const { dlg } = parts(); dlg && dlg.close(); }
      byHover = false;
    }, 250);
  });
  host.addEventListener('click', e => {
    place();
    const { btn } = parts();
    if (byHover && isOpen() && btn && e.composedPath().includes(btn)) { e.stopPropagation(); pinned = true; byHover = false; }
  }, true);
  host.addEventListener('input', () => { pinned = true; }, true);
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[data-h16-sa]');
    if (!a || !customElements.get('shopify-account')) return;
    const { btn } = parts();
    if (!btn) return;
    e.preventDefault();
    const x = document.querySelector('.d16-panel .d16-x');
    if (x) x.click();
    pinned = true; byHover = false;
    setTimeout(() => btn.click(), 60);
  });
})();

/* L2 sealimg (ORCH #3001): Seal Subscriptions adds a hidden preload div #seal-div-icon (display:none, a 10px dwn.svg) to the body on every page.
   No visitor ever sees it; on some networks the svg answers 301 text/html and the page checks count it as a broken image (headd2 rolled back).
   Remove only that div when Seal adds it. Seal's billing, widgets and the 36 contracts are untouched (Seal re-checks the id and only uses it as a preload). */
(() => {
  return; // OFF (ORCH #3008): a check fault, not a visitor fault; L1 fixes check.js/design-check.js, so no site code removes Seal's div
  const drop = () => { const d = document.getElementById('seal-div-icon'); if (d) d.remove(); };
  const start = () => {
    drop();
    if (!document.body || !window.MutationObserver) return;
    const mo = new MutationObserver(drop);
    mo.observe(document.body, { childList: true });
    setTimeout(() => mo.disconnect(), 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
